import { render, staticRenderFns } from "./new-battery-location.vue?vue&type=template&id=985868cc"
import script from "./new-battery-location.js?vue&type=script&lang=js&external"
export * from "./new-battery-location.js?vue&type=script&lang=js&external"
import style0 from "./new-battery-location.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports